import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { msg } from 'api';
import FopInfoBox from 'widgets/FopInfoBox/FopInfoBox';

export default class SubscriptionsInfoBoxContainer extends PureComponent {
  static propTypes = {
    showInfoBox: PropTypes.bool.isRequired,
    subscribedSku: PropTypes.object,
    onDismiss: PropTypes.func.isRequired,
  };

  render() {
    const msgs = msg.subscriptions.infobox;
    const { showInfoBox, onDismiss } = this.props;

    if (!showInfoBox || !this.props.subscribedSku.quantity) {
      return null;
    }

    return (
      <FopInfoBox className="sub-infoBox fop--infoBox" onDismiss={onDismiss}>
        <p className="sub-infoBox__message">{msgs.firstParagraph}</p>
        <p className="sub-infoBox__message">{msgs.secondParagraph}</p>
      </FopInfoBox>
    );
  }
}
